import React from 'react';
import { Tabs } from 'tea-component';
import { TAB_CONFIG } from './constants';
import ChannelLabel from '@op/components/ChannelLabel';
import useIntls from '@opm/hooks/useIntls';

interface ITabBarProps {
  activeKey: string;
  onActive: (info: { id: string }) => void;
}

/**
 * TabBar — 页面 Header 中的 Tab 导航条（视觉可见）
 * 仅渲染 <Tabs ceiling> 标签条，不包裹 <TabPanel>，
 * 由页面入口在 MarketContentBody 中拼接第二个 <Tabs> 负责内容渲染
 */
export default function TabBar({ activeKey, onActive }: ITabBarProps) {
  const { formatMessage } = useIntls();
  return (
    <Tabs
      ceiling
      tabs={TAB_CONFIG.map(t => {
        const key = t.key as any;
        const label = t.useChannelLabel === false
          ? formatMessage(t.label)
          : <ChannelLabel key={key} channel_name={key}></ChannelLabel>;
        return { id: t.key, label };
      })}
      animated={false}
      activeId={activeKey}
      onActive={onActive}
    />
  );
}
